module.exports = __webpack_public_path__ + "img/last-price.6da6aded.jpg";